import { SVGAttributes } from 'react';

const TruktWatermark = ({ fill = '#1c407e', ...rest }: SVGAttributes<SVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 97 86" role="img" {...rest}>
    <title>Trukt Watermark</title>
    <g id="Layer_2" data-name="Layer 2">
      <rect className="fill-transparent" width="97" height="86" />
      <path
        className="fill-[#1c407e]"
        d="M97.29,29V53c-1,.52-42.83,24.08-45.36,25.5V54.52C57.24,51.58,91.29,32.45,97.29,29Z"
      />
      <polygon
        className="fill-[#1c407e]"
        points="45.54 58.49 45.54 80.51 34.59 86.64 34.59 64.62 45.54 58.49"
      />
      <path
        className="fill-[#1c407e]"
        d="M59.88,19.18V43.11c-5.51,3.1-44.65,24.9-45.36,25.5v-24C20,41.58,59.19,19.76,59.88,19.18Z"
      />
      <polygon
        className="fill-[#1c407e]"
        points="66.27 39.15 66.27 17.13 77.22 11 77.22 33.01 66.27 39.15"
      />
    </g>
  </svg>
);

export default TruktWatermark;
